import { render, staticRenderFns } from "./ProyeccionStandbyIndex.vue?vue&type=template&id=2dcf3fcc"
import script from "./ProyeccionStandbyIndex.vue?vue&type=script&lang=js"
export * from "./ProyeccionStandbyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports